import { inject } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { Store } from '@ngrx/store'
import { environment } from 'environment/environment'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import * as fromRoot from '../../reducers'

export const authGuard = (): Observable<boolean | UrlTree> => {
  const router = inject(Router)
  const store = inject(Store<fromRoot.State>)

  return store.select(fromRoot.isLoggedIn).pipe(
    map(isUserLoggedIn => {
      if (isUserLoggedIn) return true

      const nav = router.currentNavigation()
      const attemptedUrl =
        (nav?.finalUrl && router.serializeUrl(nav.finalUrl)) ||
        (nav?.extractedUrl && router.serializeUrl(nav.extractedUrl)) ||
        router.url

      return router.createUrlTree(['/sign-in'], {
        queryParams:
          environment.minimalVersion || !attemptedUrl || attemptedUrl === '/'
            ? undefined
            : { returnUrl: attemptedUrl },
      })
    })
  )
}
